module.exports = __webpack_public_path__ + "cancellara-dist/img/aon.73fb7538.png";